import { render, staticRenderFns } from "./Receitas.vue?vue&type=template&id=4ad35bba&scoped=true"
import script from "./Receitas.vue?vue&type=script&lang=js"
export * from "./Receitas.vue?vue&type=script&lang=js"
import style0 from "./Receitas.vue?vue&type=style&index=0&id=4ad35bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad35bba",
  null
  
)

export default component.exports